import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import useSEO from '../hooks/useSEO';
import './PayMe.css';

const PayMe = () => {
  const UPI_ID = 'shyamachuthan@icici';
  const NAME = 'Shyam';

  // Custom SEO for this page
  useSEO({
    title: 'Pay Shyam - Quick UPI Payment',
    description: 'Make instant UPI payments to Shyam. Pay securely using Google Pay, PhonePe, Paytm or any UPI app.'
  });

  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [copied, setCopied] = useState(false);

  const generateUPIString = () => {
    let upiString = `upi://pay?pa=${encodeURIComponent(UPI_ID)}&pn=${encodeURIComponent(NAME)}`;
    if (amount) upiString += `&am=${encodeURIComponent(amount)}`;
    if (note) upiString += `&tn=${encodeURIComponent(note)}`;
    upiString += '&cu=INR';
    return upiString;
  };

  const payWithGooglePay = () => {
    const upiString = generateUPIString();
    window.location.href = `gpay://upi/pay?${upiString.split('?')[1]}`;
    setTimeout(() => {
      window.location.href = upiString;
    }, 1000);
  };

  const payWithPhonePe = () => {
    const upiString = generateUPIString();
    window.location.href = `phonepe://pay?${upiString.split('?')[1]}`;
    setTimeout(() => {
      window.location.href = upiString;
    }, 1000);
  };

  const payWithPaytm = () => {
    const upiString = generateUPIString();
    window.location.href = `paytmmp://pay?${upiString.split('?')[1]}`;
    setTimeout(() => {
      window.location.href = upiString;
    }, 1000);
  };

  const payWithAnyUPI = () => {
    window.location.href = generateUPIString();
  };

  const copyUpiId = () => {
    navigator.clipboard.writeText(UPI_ID);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const presetAmounts = [100, 200, 500, 1000];

  return (
    <div className="payme-page">
      <div className="payme-container">
        <div className="payme-header">
          <div className="payme-avatar">S</div>
          <h1 className="payme-name">{NAME}</h1>
          <div className="payme-upi-id" onClick={copyUpiId}>
            {UPI_ID}
            <span className="copy-hint">{copied ? '✓ Copied' : 'Click to copy'}</span>
          </div>
        </div>

        <div className="payme-qr-section">
          <div className="payme-qr-wrapper">
            <QRCodeSVG
              value={generateUPIString()}
              size={180}
              level="H"
              includeMargin={true}
              className="payme-qr"
            />
          </div>
          <p className="payme-qr-hint">Scan with any UPI app</p>
        </div>

        <div className="payme-amount-section">
          <label className="payme-label">Amount (Optional)</label>
          <div className="payme-amount-input-wrapper">
            <span className="payme-currency">₹</span>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
              className="payme-amount-input"
              min="0"
            />
          </div>
          <div className="payme-preset-amounts">
            {presetAmounts.map((preset) => (
              <button
                key={preset}
                className={`payme-preset-btn ${amount === String(preset) ? 'active' : ''}`}
                onClick={() => setAmount(String(preset))}
              >
                ₹{preset}
              </button>
            ))}
          </div>
        </div>

        <div className="payme-note-section">
          <label className="payme-label">Note (Optional)</label>
          <input
            type="text"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="What's this for?"
            className="payme-note-input"
          />
        </div>

        <div className="payme-buttons">
          <button className="payme-btn gpay" onClick={payWithGooglePay}>
            <svg viewBox="0 0 24 24" className="payme-btn-icon">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Google Pay
          </button>

          <button className="payme-btn phonepe" onClick={payWithPhonePe}>
            <svg viewBox="0 0 24 24" className="payme-btn-icon" fill="#5F259F">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15l-4-4 1.41-1.41L11 14.17l6.59-6.59L19 9l-8 8z"/>
            </svg>
            PhonePe
          </button>

          <button className="payme-btn paytm" onClick={payWithPaytm}>
            <svg viewBox="0 0 24 24" className="payme-btn-icon" fill="#00BAF2">
              <rect x="3" y="6" width="18" height="12" rx="2"/>
              <text x="12" y="14" textAnchor="middle" fill="#fff" fontSize="6" fontWeight="bold">₹</text>
            </svg>
            Paytm
          </button>

          <button className="payme-btn upi-any" onClick={payWithAnyUPI}>
            <svg viewBox="0 0 24 24" className="payme-btn-icon" fill="currentColor">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8h16v10z"/>
              <path d="M12 10c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
            </svg>
            Any UPI App
          </button>
        </div>

        {amount && (
          <div className="payme-summary">
            You're paying <strong>₹{parseFloat(amount).toFixed(2)}</strong>
            {note && <span> for "{note}"</span>}
          </div>
        )}

        <div className="payme-footer">
          <p>Secured by UPI</p>
        </div>
      </div>
    </div>
  );
};

export default PayMe;
